<bz-loading class="bmc-rpa-queueitem__loading" *ngIf="isLoading" size="l"></bz-loading>

<div class="bmc-rpa-queueitem__dashboard" *ngIf="dataQueueitemsChart && !isLoading" [style.display]="dataQueueitemsChart?'':'none'">
    <ul class="bmc-rpa-queueitem__items">
        <li class="bmc-rpa-queueitem__item">
            <bz-pie-chart [tabIndex]="tabIndex" [myIndex]="1" [idChart]="'canvasQueueitemsld'" [dataChart]="dataChartQueueitemStatusLastDay" [title]="'RPA_BOTS.LAST_24_HOURS' | translate"></bz-pie-chart>
        </li>
        <li class="bmc-rpa-queueitem__item">
            <bz-pie-chart [tabIndex]="tabIndex" [myIndex]="1" [idChart]="'canvasQueueitemslw'" [dataChart]="dataChartQueueitemStatusLastWeek" [title]="'RPA_BOTS.LAST_7_DAYS' | translate"></bz-pie-chart>
        </li>
    </ul>
    <ul class="bmc-rpa-queueitem__items">
        <li class="bmc-rpa-queueitem__item">
            <bz-pie-chart [tabIndex]="tabIndex" [myIndex]="1" [idChart]="'canvasQueueitemslm'" [dataChart]="dataChartQueueitemStatusLastMonth" [title]="'RPA_BOTS.LAST_30_DAYS' | translate"></bz-pie-chart>
        </li>
        <li class="bmc-rpa-queueitem__item">
            <bz-line-chart [tabIndex]="tabIndex" [myIndex]="1" [idChart]="'canvasQueueitemsly'" [dataChart]="dataChartQueueitemStatusLastYear" [title]="'RPA_BOTS.LAST_YEAR' | translate"></bz-line-chart>
        </li>
    </ul>
</div>

<div class="no-data" *ngIf="!dataQueueitemsChart && !isLoading" >
  {{ 'RPA_BOTS.NO_DATA_AVAILABLE' | translate }}
</div>
